import React, { ReactNode } from 'react'
import { Stepper as MUIStepper, SxProps } from '@mui/material'

interface StepperProps {
  activeStep: number
  alternativeLabel?: boolean
  children?: ReactNode
  orientation?: 'horizontal' | 'vertical'
  sx?: SxProps
}

const Stepper = React.forwardRef((props: StepperProps, ref: any) => {
  return (
    <MUIStepper {...props} ref={ref}>
      {props.children}
    </MUIStepper>
  )
})

Stepper.displayName = 'Stepper'
export default Stepper
